import {Component, Input} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'form-label',
  standalone: true,
    imports: [
        NgClass
    ],
  templateUrl: './form-label.component.html',
  styleUrl: './form-label.component.scss'
})
export class FormLabelComponent {
    @Input({ required: true }) label!: string;
    @Input() for!: string;
    @Input() danger: boolean = false;
    @Input() leftSide: boolean = false;
}
